import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

export class StatsFront {
	/**
	 * @param {HTMLElement} element
	 */
	constructor( element ) {
		this.element = element;

		this.elements();
		this.init();
	}

	elements() {
		this.numberslist = this.element.querySelector( '.stats-block-list' );
		this.numbers = this.element.querySelectorAll( '.stats-block-number-value' );
	}

	init() {
		this.tl = gsap.timeline( {
			scrollTrigger: {
				trigger: this.numberslist,
				start: 'top 80%',
			},
		} );

		let smallestValue = Infinity;

		this.numbers.forEach( ( number ) => {
			const value = parseFloat(
				number.textContent.replace( /,/g, '' ).trim()
			);
			if ( Number.isFinite( value ) && value < smallestValue ) {
				smallestValue = value;
			}
		} );

		if ( ! Number.isFinite( smallestValue ) ) {
			smallestValue = 1;
		}

		this.tl.from(this.numberslist, {
			opacity: 0,
			duration: 1,
			ease: 'power2.out',
		});

		this.numbers.forEach( ( number ) => {
			const value = parseFloat(
				number.textContent.replace( /,/g, '' ).trim()
			);
			if ( ! Number.isFinite( value ) ) {
				return;
			}

			this.tl.from( number, {
				innerText: Math.max(value - Math.max(smallestValue, 20), 0),
				snap: { innerText: 1 },
				duration: 1,
				ease: 'power2.out',
			}, 0);
		} );
	}
}
